import { runInAction } from "../../dependencies";
import { getISODate } from "../getISODate";
const isToday = (date, config) => {
    const today = getISODate(new Date(Date.now()).toISOString(), config.currentTimeZone);
    return today
        && date.getDate() === today.getDate()
        && date.getMonth() === today.getMonth()
        && date.getFullYear() === today.getFullYear();
};
const isTomorrow = (date, config) => {
    const tomorrow = getISODate(new Date(Date.now()).toISOString(), config.currentTimeZone);
    tomorrow && tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow
        && date.getDate() === tomorrow.getDate()
        && date.getMonth() === tomorrow.getMonth()
        && date.getFullYear() === tomorrow.getFullYear();
};
const getEventDate = (date, config) => {
    let eventDate = getISODate(date.toISOString(), config.currentTimeZone);
    let resultDate = config.formatDate(date.toISOString(), config.currentTimeZone);
    if (eventDate && isToday(eventDate, config)) {
        resultDate = config.dict.Today;
    }
    if (eventDate && isTomorrow(eventDate, config)) {
        resultDate = config.dict.Tomorrow;
    }
    return resultDate;
};
const mapStartDateTimeHelper = (event, config) => {
    const date = config.hasSettlementDate && event.metadata.settlementDate ?
        event.metadata.settlementDate : event.startEventDate;
    const eventDate = date ? new Date(date) : undefined;
    event.eventDate = eventDate ? getEventDate(eventDate, config) : "--";
    event.eventTime = eventDate ? config.formatTime(eventDate.toISOString(), config.currentTimeZone) : "--";
    return event;
};
export const mapStartDateTime = (event, config) => runInAction(() => mapStartDateTimeHelper(event, config));
//# sourceMappingURL=mapStartDateTime.js.map